import { environment } from '../utils/environment';
import ApiService from './ApiService';

class UsersApi extends ApiService {
  constructor(authProtected = true, fallbackRoute = '/login') {
    super(authProtected, fallbackRoute);
  }

  async login(username, password, onSuccess) {
    try {
      const formData = new URLSearchParams();
      formData.append('username', username);
      formData.append('password', password);

      const response = await this._post(environment.urls.common.login(), formData);

      if (response.data.access_token) {
        localStorage.setItem('token', response.data.access_token);
        onSuccess(response.data.access_token);
      }

      return response.data;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  }

  async register(name, email, password, is_active = false, role = null, mqtt_password = null, wifi_password = null) {
    try {
      const payload = {
        name,
        email,
        password,
        is_active,
        role,
        mqtt_password,
        wifi_password,
      };

      const response = await this._post(environment.urls.common.register(), payload);
      return response.data;
    } catch (error) {
      console.error('An error occurred while registering the new user:', error);
      throw error;
    }
  }

  async listUsers() {
    try {
      const response = await this._get('/users');
      return response.data;
    } catch (error) {
      console.error('Failed to list users:', error);
      throw error;
    }
  }

  async verifyEmail(guid) {
    try {
      const response = await this._get(`/users/verify_email/${guid}`);
      return response;
    } catch (error) {
      console.error('Email verification failed:', error);
      throw error;
    }
  }

  async resetPassword(verification_guid, newPassword) {
    try {
      const payload = { password: newPassword };
      const response = await this._post(`/users/${verification_guid}/reset_password`, payload);
      return response.data;
    } catch (error) {
      console.error('Reset password failed:', error);
      throw error;
    }
  }

  async resendVerificationEmail(email) {
    try {
      const response = await this._post('/users/resend_verification', { email });
      return response.data;
    } catch (error) {
      console.error('Failed to resend verification email:', error);
      throw error;
    }
  }
}

export default UsersApi;
